/** @module ProductSpec/SizeChart/SizeRangeView */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/html",
    "csi/html/Widget",
	"csi/widget/FormGroupContainer",
	"csi/widget/MockSizeChartPropertiesChanging",
	"csi/xml"
], function(declare,_,html,HtmlWidget,FormGroupContainer,MockSizeChart,xml) {
	/**
	 * This is view widget for Size Chart -> Size Range selection view
	 * UI Path: Home/Styles/Style->Style/Specification/SizeChart->SizeChart/Properties -> Size Range" tooltip "Edit"
	 * ProductSpec.xml
	 * View Id="Increment" xsi:type="Html"
	 * Template="ProductSpec/SizeChart/SizeRangeView.html"
	 * ControllerClass="ProductSpec/SizeChart/SizeRangeView"
	 */

	return declare(HtmlWidget, {

		/**@property {boolean} saveDisabled - vutton Save disabled status. True for disabled */
		saveDisabled: true,
		/** @property {string} newSizeRange - Size Range new selection */
		newSizeRange: "",
		/** @property {string} newIncrement - Increment new selection */
		newIncrement: "",
		/** @property {string} newProductGroup - Product Group new selection */
		newProductGroup: "",
		/** @property {boolean} maintainBaseSize - radio group "Maintain Base Size" selection */
		maintainBaseSize: false,
		/** @property {boolean} maintainTolerances - radio group "Maintain Tolerances" selection */
		maintainTolerances: false,
		/** @property {boolean} maintainDimensions - radio group "Maintain Dimensions" selection  */
		maintainDimensions: false,
		/** @property {boolean} maintainIncrements - radio group "Maintain Increments" selection  */
		maintainIncrements: false,

		/** reference to incrementForm widget */
		incrementForm: null, 

		/** reference to productGroupForm widget */
		productGroupForm: null,

		/**
		 * @override
		 * Add Size Chart Mockup at the bottom of html view
		 */
		_postView: function() {
			this.inherited(arguments);

			// This delay required to ensure that Widget's html is alredy in the dom. Othervise  creating mockup will fail
			_.delay(()=>{
				new FormGroupContainer({
					additionalWidget: new MockSizeChart({
						excludeGroups: [],
						onClick: values => {
							this.maintainIncrements = values.maintainIncrements;
							this.maintainTolerances = values.maintainTolerances;
							this.maintainDimensions = values.maintainDimensions;
							this.maintainBaseSize = values.maintainBaseSize;
							this.refreshSaveBtn();
						}
					})
				}).placeAt("productSizeChartWizard");
				this.incrementForm.refreshRadioGroup();
				this.productGroupForm.refreshRadioGroup();
			});
		},

		/**
		 * @ovrride
		 * Control enabled/disabled status of dialog Save action button
		 */
		canEnableButton: function(button, idAction) {
			return (idAction != "Save") || !this.saveDisabled;
		},

		/**
		 * Control enabled/disabled status of dialog Save button
		 */
		refreshSaveBtn: function() {
			const jNode = $(this.domNode);
			const jChecked = jNode.find(".csi-size-chart-mock-table-container :not(.dijitDisabled).dijitChecked .dijitCheckBoxInput");
			const numChecked = jChecked.length;

			// Calculate number of radio group selections that user should make to complete the form
			var numSelectionRequired =  2;
			if (this.changeProductGroup) {
				numSelectionRequired++;
			}
			if (this.changeIncrement) {
				numSelectionRequired++;
			}
			// Calculate if button save should be disabled. "True" means "Disabled".
			this.saveDisabled = (numChecked < numSelectionRequired) || !xml.isValidURL(this.newSizeRange)
									|| (this.changeProductGroup && !xml.isValidURL(this.newProductGroup))
									|| (this.changeIncrement && !xml.isValidURL(this.newIncrement));
			// Enable actions buttons. Function canEnableButton() will check for this.saveDisabled value for button "Save"
			this._setActionButtonsDisabled(false);
		}

	});
});